/*
 * Snapsvg has many useful SVG path tools -- but the library depends on a browser, even though the path tools don't
 *
 * The files in this folder:
 *
 * - snapsvg-path.js taken straight from snapsvg
 * - snapsvg-stub.js implements just enough of the rest of snapsvg for snapsvg-path to run
 *
 * @see http://snapsvg.io
 */
import { toCubic, isPointInside } from './snapsvg-stub'

export default {
    toCubic,
    isPointInside,
}
